import { classify } from 'sidecar-utilities'

export const helpNavStyles = classify({
  flex: 'flex items-center shrink-0 gap-6',
})

export const helpMenuStyles = classify({
  size: 'w-64',
  // convert a normally centered menu to right aligned
  position: 'absolute -right-3',
  // prevents scrolling in the menu to trigger scrolling in the background
  overScroll: 'overscroll-y-contain',
})

export const badgeStyles = classify({
  iconColor: 'color-iconRisk-default',
  // The icon is actually a square with a circle in it.
  // So we need rounded to make the square parent match the icon.
  // That way, the iconBorder will be round.
  parentShape: 'rounded-full',
  // Custom shadow gives the circle a border outside of the shape (rather than inside of it)
  iconBorder:
    'shadow-[0_0_0_3px_rgba(255,255,255,1)] dark:shadow-[0_0_0_3px_rgba(255,255,255,1)]',
  // Put the badge on top of the letter
  position: 'absolute -top-1 -right-1.5',
  onTopOfLetter: 'z-1',
})
